import { GraphQLMutationSignedClass } from "@eco/client";
import { useEcoClient } from "hooks";
import { useCallback } from "react";
import useEcoMutation, { useEcoMutationOptions } from "./useEcoMutation";
import { useGrapqhlSignedQuery } from "./useGrapqhlSignedQuery";

/**
 * 
 * Custom hook to query from Ecomundo graphQL API to mutate data
 * You can perform data mutation within this hook
 * Onthology feature is supported too
 * Please refer to the documentation : https://redmine.ecomundo.tech/projects/it/wiki/GraphQL
 * Grapqhl sandbox is avalaible on "bo" application https://saka.ecomundo.tech/bo/
 * 
 */
export const useGraphQLMutation = <TClass extends GraphQLMutationSignedClass, TData=unknown, TError=unknown>(
        query: TClass,
        config?: useEcoMutationOptions<TData, TError, TClass['variables']>
    ) => {

    const ecoClient = useEcoClient();
    const signedQuery = useGrapqhlSignedQuery(query)

    const mutationFn = useCallback((variables: TClass['variables']): Promise<TData> => {
        return ecoClient.graphql<TData, TClass['variables']>({
            ...signedQuery,
            variables: {
                filter: query.filter,
                ...variables,
            },
        })
    }, [query])
    
    return useEcoMutation<TData, TClass['variables'], TError>(mutationFn, config)
}
